<template>
  <v-avatar :size="size" :style="{ 'background-color': getColor(bgColor) }">
    <v-icon :size="iconSize" :style="{ color: getColor(color) }">
      {{ icon }}
    </v-icon>
  </v-avatar>
</template>

<script setup>
const props = defineProps({
  icon: String,
  color: String,
  bgColor: String,
  size: {
    type: [String, Number],
    default: 40,
  },
});

const getColor = (color) => {
  if (!color) return;
  return color.startsWith("#") ? color : `rgb(var(--v-theme-${color}))`;
};

const iconSize = computed(() => {
  return props.size * 0.6;
});
</script>
